import api from '../../api/api';
import {GET_CUSTOM_FORM_DATA} from '../actionTypes';
import {UPDATE_CUSTOM_FORM_DATA} from '../mutationTypes';

export default {
  [GET_CUSTOM_FORM_DATA]: async ({commit, state, getters}, alias) => {
    const form = await api.customFormApi.get_custom_form(alias);
    commit(UPDATE_CUSTOM_FORM_DATA, {data: form, alias: alias, getters});
    return form;
  },
};
